export default __webpack_public_path__ + "static/media/Watch.207a344b.jpg";